import { render, staticRenderFns } from "./Lections.vue?vue&type=template&id=1f24b955&"
import script from "./Lections.vue?vue&type=script&lang=js&"
export * from "./Lections.vue?vue&type=script&lang=js&"
import style0 from "./Lections.vue?vue&type=style&index=0&id=1f24b955&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports